module.exports = __webpack_public_path__ + "static/media/smartdrive-logo-green.f59aae72.svg";